// LaunchDarkly flag keys for Inventory Service V2 migration
export const INVENTORY_PRODUCTS_LIST_V2 = 'releaseBeInventoryProductsListV2';
export const INVENTORY_PRODUCTS_LIST_V2_BY_ORG =
  'releaseBeInventoryProductsListV2ByOrg';
